import { AppConfigService } from '@app-shared/services';
import { CookieService } from 'ngx-cookie-service';

export function initializeApp(appConfigService: AppConfigService, cookieService: CookieService) {
  return (): Promise<void> => {

    return appConfigService.load();
  }
}